module.exports = __webpack_public_path__ + "static/media/Library.aaa9e516.svg";